import { atom } from 'jotai';

export interface AddRoleFormData {
  name: string;
  permissions: Record<string, boolean>;
}

const getInitialFormData = (): AddRoleFormData => ({
  name: '',
  permissions: {},
});

export const $addRoleDialogOpen = atom(false);
export const $addRoleFormData = atom<AddRoleFormData>(getInitialFormData());

export const $openAddRoleDialog = atom(null, (_get, set) => {
  set($addRoleFormData, getInitialFormData());
  set($addRoleDialogOpen, true);
});

export const $closeAddRoleDialog = atom(null, (_get, set) => {
  set($addRoleDialogOpen, false);
  set($addRoleFormData, getInitialFormData());
});

export const $updateAddRoleForm = atom(
  null,
  (get, set, update: Partial<AddRoleFormData>) => {
    set($addRoleFormData, { ...get($addRoleFormData), ...update });
  },
);

export const $addRoleFormValid = atom((get) => {
  const form = get($addRoleFormData);
  return form.name.trim() !== '';
});
